/* eslint-disable consistent-return */

function setPlacement(state, placement) {
  return Object.assign(state, {
    placement
  });
}

/*
 * textDirectionSensitive is a modifier for popper.js. It reads the text direction of the
 * reference element and mirrors placement direction when detecting rtl mode.
 */
function textDirectionSensitiveFn({
  state
}) {
  var _state$elements, _reference$ownerDocum, _getComputedStyle, _state$options;
  /* test for the existence of the reference element */
  const reference = state === null || state === void 0 || (_state$elements = state.elements) === null || _state$elements === void 0 ? void 0 : _state$elements.reference;
  if (!(reference instanceof HTMLElement)) {
    return;
  }

  /* test for the existence of the getComputedStyle function and get a reference to it */
  const getComputedStyle = reference === null || reference === void 0 || (_reference$ownerDocum = reference.ownerDocument) === null || _reference$ownerDocum === void 0 || (_reference$ownerDocum = _reference$ownerDocum.defaultView) === null || _reference$ownerDocum === void 0 ? void 0 : _reference$ownerDocum.getComputedStyle;
  if (!(typeof getComputedStyle === 'function') || !getComputedStyle) {
    return;
  }

  /* get text direction of the reference element */
  const direction = (_getComputedStyle = getComputedStyle(reference)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.direction;

  /* do nothing when non-RTL direction is detected */
  if (!(direction === 'rtl')) {
    return;
  }

  /* Mirror placements on rtl mode */
  switch (state === null || state === void 0 || (_state$options = state.options) === null || _state$options === void 0 ? void 0 : _state$options.placement) {
    case 'left-start':
      return setPlacement(state, 'right-start');
    case 'left':
      return setPlacement(state, 'right');
    case 'left-end':
      return setPlacement(state, 'right-end');
    case 'right-start':
      return setPlacement(state, 'left-start');
    case 'right':
      return setPlacement(state, 'left');
    case 'right-end':
      return setPlacement(state, 'left-end');
    case 'top-start':
      return setPlacement(state, 'top-end');
    case 'top-end':
      return setPlacement(state, 'top-start');
    case 'bottom-start':
      return setPlacement(state, 'bottom-end');
    case 'bottom-end':
      return setPlacement(state, 'bottom-start');
  }
}

export { textDirectionSensitiveFn as t };
//# sourceMappingURL=textDirectionSensitive-CsCfX-rl.js.map
